export class BaseClass {
    id: number;
    name: string;
    active: boolean;
}